import { ApiKey_value } from '@cf/api-v2-types';
import { simpleCreateMutation, simpleCreateQuery } from '$lib/utils/simpleQueryMutations';

export const useKey_valueReadQuery = () => {
	return simpleCreateMutation(async (data: any) => {
		const apiKey_value = new ApiKey_value('/proxy');
		const result = await apiKey_value.read(data);
		return result;
	});
};

export const useKey_valueCreateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiKey_value = new ApiKey_value('/proxy');

		const result = await apiKey_value.create(data);
		return result;
	});
};

export const useKey_valueUpdateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiKey_value = new ApiKey_value('/proxy');

		const result = await apiKey_value.update(data);
		return result;
	});
};

export const useKey_valueDeleteMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiKey_value = new ApiKey_value('/proxy');

		const result = await apiKey_value.delete(data);
		return result;
	});
};
